import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  postRequestWithFiles,
  putRequestWithFiles,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getActivities(GetActivityData, id) {
  return postRequest(
    `/${globalConstants.VERSION}/CenterActivity/center/${id}`,
    GetActivityData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getActivityById(id) {
  return getRequest(`/${globalConstants.VERSION}/CenterActivity/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addActivity(activityData) {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/CenterActivity`,
    activityData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function publishActivity(id) {
  return putRequest(
    `/${globalConstants.VERSION}/CenterActivity/publish/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateActivity(activityData) {
  return putRequestWithFiles(
    `/${globalConstants.VERSION}/CenterActivity`,
    activityData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateActivityStatusById(activityData, id) {
  return putRequest(
    `/${globalConstants.VERSION}/CenterActivity/updateStatus/${id}`,
    activityData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteActivityById(id) {
  return deleteRequest(`/${globalConstants.VERSION}/CenterActivity/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getCalenderEvents(GetCalenderData) {
  return postRequest(
    `/${globalConstants.VERSION}/Calendar`,
    GetCalenderData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
export const centerActivityService = {
  getActivities,
  getActivityById,
  addActivity,
  publishActivity,
  updateActivity,
  updateActivityStatusById,
  deleteActivityById,
  getCalenderEvents
};
